import React from 'react'
import {useTranslation} from 'i18n'
import {FirebaseMessageRoomItemPayload} from 'types'
import {getFontFamily} from 'utils'
import {Paragraph, ParsedText} from 'common/components'

export interface GiftShopMessageRoomContentItemNotificationFollowGroupProps {
  payload: FirebaseMessageRoomItemPayload['notification_follow_group']
}

export default function GiftShopMessageRoomContentItemNotificationFollow({
  payload: {count},
}: GiftShopMessageRoomContentItemNotificationFollowGroupProps) {
  const {translate} = useTranslation()

  return (
    <Paragraph fontSize="m">
      <ParsedText
        parse={[
          {
            pattern: /<bold>.*?<\/bold>/,
            style: {
              fontFamily: getFontFamily('bold'),
            },
            renderText: (text) => text.replace(/<bold>|<\/bold>/g, ''),
          },
        ]}>
        {translate('messages:notificationFollow', {
          username: `${count} ${translate('global:yuser', {count})}`,
        })}
      </ParsedText>
    </Paragraph>
  )
}
